module.exports = __webpack_public_path__ + "img/02_img.7ecd54b6.png";